import React from "react";
import {ActivateLocationEpic, UpdateLocationPropertyEpic, GetLocationTenderTypesEpic} from '../../actions/location.actions';
import {connect} from 'react-redux'
import { withRouter } from 'react-router-dom'
import {Card, CardHeader, CardText} from 'material-ui/Card';
import ActivateLocationDialog from './ActivateLocationDialog';
import RaisedButton from 'material-ui/RaisedButton'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

export class LocationPayments extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      table: null,
      showActivateDialog: false,
    };
    this.linkStripe = this.linkStripe.bind(this);
    
  }


  onCloseActivate = () => {
    this.setState({showActivateDialog: false});
  }

  onSubmitActivation = (locationId, omnivoreId) => {
    this.props.activateLocation(locationId, omnivoreId);
  }
 

  linkStripe() {
    const stripeUrl = 'https://connect.stripe.com/oauth/authorize';
    const stripeClientId = this.props.selectedLocation.stripeConnectId;
    const queryParams = [
      'response_type=code',
      `client_id=${stripeClientId}`,
      'scope=read_write',
      `state=${this.props.selectedLocation._id}`,
    ];
    window.location.href = `${stripeUrl}?${queryParams.join('&')}`;
  }

  handleTenderTypeChange = (event, index, value) => {
    console.log('Changing tender type', value);
    this.props.onTenderTypeChange(value)
  };

  omnivoreData = () => {
    console.log('Tender Type', this.props.selectedLocation);
    let locationId = this.props.selectedLocation.systemType && this.props.selectedLocation.systemType.options? 
      this.props.selectedLocation.systemType.options.locationId 
      : 
      <RaisedButton onClick={() => this.setState({showActivateDialog: true})} label="Activate" primary={true}/>;
    return (
    <div>
      <div style={{fontWeight: 'bold'}}>Omnivore Location ID: </div>
      <div>{locationId} </div>
      <SelectField floatingLabelText="Tender Type" value={this.props.selectedLocation.tenderType} onChange={this.handleTenderTypeChange}>
        {this.props.tenderTypes.map(tt => {
          return <MenuItem key={tt.id} value={tt.id} primaryText={tt.name}/>;
        })}
      </SelectField>
    </div>);
  }

  render() {
    return (
      <div>
        <Card>
          <CardHeader title="Ready Activation" titleStyle={{fontWeight: 'bold', color: '#1cb7ff'}}></CardHeader>
          <CardText>
          {this.omnivoreData()}
          <br/>
          <div><div style={{fontWeight: 'bold', paddingRight: 10}}>Stripe:</div>
          <img src='/blue-on-light.png' alt="Connect To Stripe" onClick={this.linkStripe} style={{cursor: 'pointer', verticalAlign:'middle'}}/>
          {this.state.showActivateDialog? 
            <ActivateLocationDialog 
              show={this.state.showActivateDialog} 
              closeDialog={this.onCloseActivate} 
              onSubmit={this.onSubmitActivation} 
              loading={this.props.activationInProgress} 
              activationError={this.props.activationError} 
              location={this.props.selectedLocation}
            /> 
            : 
            null
          }</div>
          </CardText>
        </Card><br/>
      </div>
    );
  }
}

let mapStateToProps = ({locationsEndpoint, referenceData},{match}) => ({
  loading: locationsEndpoint.fetchInProgress,
  activationInProgress: locationsEndpoint.activationInProgress,
  error: locationsEndpoint.fetchError? true:false,
  locationId: match.params.locationId,
  activationError: locationsEndpoint.activationError,
  tenderTypes: locationsEndpoint.tenderTypes
})

let mapDispatchToProps = (dispatch) => ({
  activateLocation: (locationId,omnivoreId) => dispatch(ActivateLocationEpic(locationId, omnivoreId)),
  updateLocation: (locationId, updates) => dispatch(UpdateLocationPropertyEpic(locationId, updates)),
  getTenderTypes: (locationId) => dispatch(GetLocationTenderTypesEpic(locationId))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LocationPayments));



// WEBPACK FOOTER //
// ./src/containers/Locations/LocationPaymentSettings.js